// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressesController from "./addresses_controller"
application.register("addresses", AddressesController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import BomsController from "./boms_controller"
application.register("boms", BomsController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import ExternalShipmentController from "./external_shipment_controller"
application.register("external-shipment", ExternalShipmentController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FormActionsController from "./form_actions_controller"
application.register("form-actions", FormActionsController)

import FormFieldInputsController from "./form_field_inputs_controller"
application.register("form-field-inputs", FormFieldInputsController)

import GridjsController from "./gridjs_controller"
application.register("gridjs", GridjsController)

import InvoiceController from "./invoice_controller"
application.register("invoice", InvoiceController)

import LightgalleryController from "./lightgallery_controller"
application.register("lightgallery", LightgalleryController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import PartOrderController from "./part_order_controller"
application.register("part-order", PartOrderController)

import PartOrderTrackingController from "./part_order_tracking_controller"
application.register("part-order-tracking", PartOrderTrackingController)

import PurchaseOrderShipmentsController from "./purchase_order_shipments_controller"
application.register("purchase-order-shipments", PurchaseOrderShipmentsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ShepherdController from "./shepherd_controller"
application.register("shepherd", ShepherdController)

import ShipmentsController from "./shipments_controller"
application.register("shipments", ShipmentsController)

import ShippingCostController from "./shipping_cost_controller"
application.register("shipping-cost", ShippingCostController)

import ShippingRatesController from "./shipping_rates_controller"
application.register("shipping-rates", ShippingRatesController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SquareController from "./square_controller"
application.register("square", SquareController)

import TicketsController from "./tickets_controller"
application.register("tickets", TicketsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserTrackingController from "./user_tracking_controller"
application.register("user-tracking", UserTrackingController)

import SalesOrderController from "./sales_order_controller"
application.register("sales-order", SalesOrderController)
